import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'

const RouteContainer = (props) => {
  const { children, onRouteChange } = props
  const history = useHistory()

  useEffect(() => {
    return history.listen((location) => {
      onRouteChange(location.pathname)
    })
  }, [history])

  return (
    <div>{children}</div>
  )
}

RouteContainer.propTypes = {
  children: PropTypes.node.isRequired,
  onRouteChange: PropTypes.func.isRequired
}

RouteContainer.defaultProps = {
}

export default RouteContainer
